<template>
    <div id="ContainerClinicalePharmacy">
        <ePharmacyBase v-bind:Origin="'Clinical'" v-if="authed" />

        <MdPasswordDlg v-if="showSignPassword" 
            v-bind:Type="TypePassWord"
            v-bind:UserId="UserId"
            @getModalPassword="onModalPasswordResult($event)"/>
    </div>
</template>
<script>
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import EnumService from '@/services/enum.service' 
import Permission from '@/common/Permission'
import NewCropService from '@/services/newcrop.service'
import LocalStorage from '@/services/storage.service';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.canExit) {
            next();
        } else {
            this.Loading = true;
            this.$emit('load', this.Loading);

            this.MedicationImport().then(() => {
                this.Loading = false;
                this.$emit('load', this.Loading);

                next();
            }).catch((error) => {
                this.Loading = false;
                this.$emit('load', this.Loading);

                if (!error.response) {            
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
                this.canExit = true;
            });
        }
    },
  name: 'ePharmaryClinical',
   mixins: [DBFunctions, Permission],

   data(){
       return{
        //permission:[],
        OptionsRightMenu: {
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''         
        },
        canExit: false,
        UserId:LocalStorage.getUserId(),
        showSignPassword:true,
        TypePassWord:'Sign',
        authed: false
        //Menu : this.$store.state.leftMenu,
       }
   },

    methods:{
        async MedicationImport() {
            await NewCropService.medicationImport(this.$route.params.id).then(() => {
            })
        },

        saveChecked(){
            this.imported = true;
        },

        onModalPasswordResult(result){      
            if(result.Event === 'Ok' && result.status === true){   
                this.authed = true;
                this.showSignPassword = false;
            } else {
                this.showMessage(this.$tc('Msg.Error'),result.message,"error");
            }
        },
    },

    created(){
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
    },

    mounted(){
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointmentDB-epharmacy') ? EnumService.AppointmentItems : EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
   },

   destroyed(){
     
   }
};
</script>